import * as React from 'react';
import { useParams } from 'react-router-dom';
import dashboardWrapper from '~/wrappers/dashboard';
import { Panel, Spinner } from '@ixicare/ui';
import ResidentFormContainer from '~/containers/Residents/ResidentForm';
import { t } from '~/i18n';
import { State } from '~/store/types';
import connect from '~/store/connect';
import ErrorContainer from '~/containers/Error';
import BackLink from '~/components/BackLink';
import { Permission } from '@ixicare/resources';

interface ResidentUpdatePageProps {
  profile: State['residentDetail']['profile'];
  loadResident: State['residentDetail']['loadResident'];
  residentLoading: State['residentDetail']['loading'];
  residentError: State['residentDetail']['error'];
}

const ResidentUpdatePage: React.FC<ResidentUpdatePageProps> = ({
  profile,
  loadResident,
  residentError,
  residentLoading,
}) => {
  const { id } = useParams<{ id: string }>();
  const residentId = id ? parseInt(id, 10) : 0;
  const [editPermission, setEditPermission] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (residentId) {
      loadResident(residentId.toString());
    }
  }, [residentId, loadResident]);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((value) => {
      if (value.length != 0) {
        value[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_edit_all_profiles')) {
            if (perm.isEnabled) {
              setEditPermission(true);
            }
          }
        });
      }
    });
  }, []);

  if (residentLoading) {
    return <Spinner label={t('global.loading')} />;
  }
  if (!editPermission) {
    return (
      <Panel>
        <p>{t('user-configuration.no-permissions')}</p>
      </Panel>
    );
  }
  return (
    <>
      <BackLink fallbackUrl={`/residents`} name={t('residentDetail.goBackToDetail')} />
      <ErrorContainer error={residentError ?? undefined} />
      {!residentError && (
        <Panel>
          <ResidentFormContainer profile={profile} />
        </Panel>
      )}
    </>
  );
};

const ConnectedResidentUpdatePage = connect((state: State) => ({
  profile: state.residentDetail.profile,
  loadResident: state.residentDetail.loadResident,
  residentLoading: state.residentDetail.loading,
  residentError: state.residentDetail.error,
}))(ResidentUpdatePage);

export default dashboardWrapper(ConnectedResidentUpdatePage, t('residents.update.title'));
